<script>
  import { Preview } from '@client/components/preview';
  import { Spinner } from '@client/components/spinner';

  export let url = {};
  export let show = false;

  let containerRef = null;
</script>

<div bind:this={containerRef} class="preview">
  <Preview bind:show bind:url frameMinHeight="740px" minWidth="200px" />
</div>

<style lang="scss" src="./bizcard-preview.scss"></style>
